export const missions = [
  { id: 1, mot: "Puissance" },
  { id: 2, mot: "Argent" },
  { id: 3, mot: "Respect" },
  { id: 4, mot: "Confiance" },
  { id: 5, mot: "Courage" },
  { id: 6, mot: "Travail" },
  { id: 7, mot: "NOM_LIBRE" },
  { id: 8, mot: "Succès" },
  { id: 9, mot: "Motivation" },
  { id: 10, mot: "Sagesse" },
  { id: 11, mot: "Leadership" },
  { id: 12, mot: "Richesse" },
  { id: 13, mot: "Victoire" },
  { id: 14, mot: "Force" },
  { id: 15, mot: "Patience" },
  { id: 16, mot: "Fidélité" },
  { id: 17, mot: "Amour" },
  { id: 18, mot: "Foi" },
  { id: 19, mot: "Vision" },
  { id: 20, mot: "Objectif" },
  { id: 21, mot: "Ambition" },
  { id: 22, mot: "Créativité" },
  { id: 23, mot: "Persévérance" },
  { id: 24, mot: "Humilité" },
  { id: 25, mot: "Gratitude" },
  { id: 26, mot: "Sérénité" },
  { id: 27, mot: "Excellence" },
  { id: 28, mot: "Clarté" },
  { id: 29, mot: "Stabilité" },
  { id: 30, mot: "Liberté" },
  { id: 31, mot: "Énergie" },
  { id: 32, mot: "Intelligence" },
  { id: 33, mot: "Compassion" },
  { id: 34, mot: "Équilibre" },
  { id: 35, mot: "Authenticité" },
  { id: 36, mot: "Innovation" },
  { id: 37, mot: "Connaissance" },
  { id: 38, mot: "Solidarité" },
  { id: 39, mot: "Partage" },
  { id: 40, mot: "Bonté" },
  { id: 41, mot: "Calme" },
  { id: 42, mot: "Justice" },
  { id: 43, mot: "Générosité" },
  { id: 44, mot: "Respect" },
  { id: 45, mot: "Honneur" },
  { id: 46, mot: "Dignité" },
  { id: 47, mot: "Éducation" },
  { id: 48, mot: "Perspicacité" },
  { id: 49, mot: "Empathie" },
  { id: 50, mot: "Bienveillance" },
  { id: 51, mot: "Sincérité" },
  { id: 52, mot: "Lumière" },
  { id: 53, mot: "Croissance" },
  { id: 54, mot: "Détermination" },
  { id: 55, mot: "Résilience" },
  { id: 56, mot: "Responsabilité" },
  { id: 57, mot: "Optimisme" },
  { id: 58, mot: "Beauté" },
  { id: 59, mot: "Création" },
  { id: 60, mot: "Clémence" },
  { id: 61, mot: "Espoir" },
  { id: 62, mot: "Harmonie" },
  { id: 63, mot: "Prospérité" },
  { id: 64, mot: "Santé" },
  { id: 65, mot: "Joie" },
  { id: 66, mot: "Partenariat" },
  { id: 67, mot: "Fraternité" },
  { id: 68, mot: "Influence" },
  { id: 69, mot: "Puissance" },
  { id: 70, mot: "Autorité" },
  { id: 71, mot: "Discrétion" },
  { id: 72, mot: "Discipline" },
  { id: 73, mot: "Évolution" },
  { id: 74, mot: "Inspiration" },
  { id: 75, mot: "Vérité" },
  { id: 76, mot: "Lucidité" },
  { id: 77, mot: "Pardon" },
  { id: 78, mot: "Protection" },
  { id: 79, mot: "Cohérence" },
  { id: 80, mot: "Chaleur" },
  { id: 81, mot: "Ouverture" },
  { id: 82, mot: "Apprentissage" },
  { id: 83, mot: "Savoir" },
  { id: 84, mot: "Soutien" },
  { id: 85, mot: "Victoire" },
  { id: 86, mot: "Patrimoine" },
  { id: 87, mot: "Satisfaction" },
  { id: 88, mot: "Bien-être" },
  { id: 89, mot: "Richesse" },
  { id: 90, mot: "Célébration" },
  { id: 91, mot: "Bénédiction" },
  { id: 92, mot: "Maturité" },
  { id: 93, mot: "Héroïsme" },
  { id: 94, mot: "Dépassement" },
  { id: 95, mot: "Transformation" },
  { id: 96, mot: "Crédo" },
  { id: 97, mot: "Solidité" },
  { id: 98, mot: "Renaissance" },
  { id: 99, mot: "Triomphe" },
  { id: 100, mot: "Florinato" }
];
